import { agroApi } from "../../../redux/api/api";

export const CameraApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
    CameraStart: builder.mutation({
      query: (cameraId: number) => ({
        url: `/stream/start/${cameraId}`,
        method: "POST",
      }),
    }),
    CameraStop: builder.mutation({
      query: (cameraId: number) => ({
        url: `/stream/stop/${cameraId}`,
        method: "POST",
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useCameraStartMutation, useCameraStopMutation } = CameraApi;